import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButton],
  template: `<div class="dialog__header">
      <h1 class="dialog__title" mat-dialog-title>Contact Deleted</h1>
      <mat-icon mat-button mat-dialog-close class="dialog__icon dialog__close" fontIcon="close"></mat-icon>
    </div>
    <mat-dialog-content>
      <p>
        The contact was successfully deleted. Please note that it may take up to 5 minutes for this deletion to be reflected in the Contacts list.
      </p>
      <p>Please email support if the deleted contact still appears in the contact list after 24 hours has passed.</p>
      <mat-dialog-actions>
        <div>
          <button tabindex="-1" mat-raised-button [mat-dialog-close]="true">Ok</button>
        </div>
      </mat-dialog-actions>
    </mat-dialog-content>`,
})
export class AccountRemoveContactSuccessComponent {}
